import { Enum } from '@lighthouse/tools'

import type {
    AlignMent,
    AnchorProtocol,
    Arrangement,
    BackgroundNoImageProtocol,
    BaseBreakPointProtocol,
    BLOCK_SIZE,
    BlockSize,
    CursorProtocol,
    Direction,
    FileType,
    Fit,
    IndependentAction,
    Shape,
    SizeConfigure,
    VariableADTvalue
} from '../../protocols'
import type { EventsProtocol } from '../../protocols/event'
import { BlockType } from '../Basic'
import { BaseBlock } from './BaseBlock'

export interface ImageSwiperItem {
    url: string
    name: string
    type: FileType
    title: string
    link: string
    size: number
}

export const IMAGE_SHOW_TYPE = Enum('single', 'multiple', 'grid')
export type ImageShowType = Enum<typeof IMAGE_SHOW_TYPE>

export const IMAGE_SOURCE_TYPE = Enum('default', 'field')
export type ImageSourceType = Enum<typeof IMAGE_SOURCE_TYPE>

export interface ImageOptions extends BaseBreakPointProtocol, EventsProtocol, AnchorProtocol {
    // design
    showType?: ImageShowType
    align: AlignMent
    fitType: Fit
    shape: Shape
    ratio?: string
    radius?: string
    gridGap?: SizeConfigure
    // arrangement?: Arrangement
    gridItemWidth?: SizeConfigure
    gridShowCount?: string
    listItemHeight?: SizeConfigure
    size?: Exclude<BlockSize, typeof BLOCK_SIZE.xs>
    // cols?: number
    // rows?: number
    /** 背景色 */
    background?: BackgroundNoImageProtocol
    cursor?: CursorProtocol
    direction?: Direction
    // configure
    // 图片来源
    sourceType: ImageSourceType
    /** sourceType为default时的上传列表 */
    sources?: ImageSwiperItem[]
    /** sourceType为field时的图片变量 */
    imageSource?: VariableADTvalue
    /** 开启轮播图模式 */
    carousel?: boolean
    /** 禁用懒加载 */
    noLazy?: boolean
    /** 自动播放 */
    autoPlay?: boolean
    /** 切换速度 */
    swipeSpeed: number
    /** 压缩 */
    compress?: boolean
    /** 图片预览 */
    isPreview?: boolean
}

export abstract class ImageBlockAbstract extends BaseBlock {
    type = BlockType.image

    abstract override config: ImageOptions
}
